import styled from '@emotion/styled'
import darken from 'polished/lib/color/darken'
import * as React from 'react'

import { CaretDownIcon, CaretUpIcon, palette } from 'main/ui'

interface IProps {
  open: boolean
  onChange: (open: boolean) => void
}

const IconContainer = styled.div`
  color: ${palette.mediumGray};
  cursor: pointer;
  width: 15px;

  &:hover {
    color: ${darken(0.1, palette.mediumGray)};
  }
`

export default function Control(props: IProps) {
  const { open, onChange } = props

  return (
    <div>
      <IconContainer onClick={() => onChange(!open)}>
        {open ? <CaretUpIcon /> : <CaretDownIcon />}
      </IconContainer>
    </div>
  )
}
